<div class="main-container">
  <app-navbar  *ngIf="isLogin"></app-navbar>
  <div class="content-container">
      <div class="content-area">
        <div class="pt-2">
          <div class="clr-row">
            <div class="clr-col-12">
              <h1 style="text-align: center;">404 Error</h1>
            </div>
            <div class="clr-col-12">
              <p class="error-message">The Data Collection & Information System page specified does not exist or the system is unavailable.</p>
            </div>
          </div>
        </div>
        <div class="pt-6">
          <div class="clr-row">
            <div class="clr-col-12">
              <p class="contact-text">For assistance, contact the Ontario Health - CorHealth Ontario Service Desk</p>
            </div>
            <div class="clr-col-12">
              <p class="contact-text">Monday to  Friday, 8:30 am to 5:00 pm</p>
            </div>
            <div class="clr-col-12">
              <p class="contact-text">416-512-7472 ext. 1</p>
              <p class="contact-text"><a class="contact-text" href="mailto:OH-CORH_Service@ontariohealth.ca">OH-CORH_Service@ontariohealth.ca</a>
              </p>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>

